var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M12 13.41c1.289 0 2.48-.363 3.434-.98a1.935 1.935 0 0 1 2.347.195 8.6 8.6 0 0 1 2.82 6.383v1.043A1.95 1.95 0 0 1 18.649 22H5.351a1.95 1.95 0 0 1-1.953-1.95v-1.042a8.57 8.57 0 0 1 2.817-6.38 1.935 1.935 0 0 1 2.347-.194c.957.613 2.145.976 3.438.976M12 11.672A4.836 4.836 0 1 0 12 2a4.836 4.836 0 0 0 0 9.672"
})));
export default SvgUser;